import React from 'react';
import { Overlays } from '../overlays';
import Typo from '../typo';
import FormationPlayerCard from '../formationPlayerCard';
import PlayerSkillIcon from '../playerSkillIcon';

const OverlaySelectedTeam = ({ show, onClose, errorMessage }) => {
  return (
    <>
      <Overlays
        overlayName={'selectionTeam'}
        overlayConfig={{
          noOverlayHead: true,
          overlayCloseConfig: true,
          noOverlayClose: true,
          noOverlayBody: true,
          noOverlayFoot: true,
          noOverlayReset: false,
          submitBtn: false,
          cancelBtn: false,
          title: 'INFO',
          titleTransKey: 'overlay_title_warning',
          caption: 'You have already created a team for this match.',
          captionTransKey: 'overlay_warning_caption_0',
          onClickProp: onClose
        }}
      >
        {/* <div className='si-selectionTeam'>
          <Typo component='span' className='si-fixture__versus'>
            {errorMessage}
          </Typo>
          <div className='si-selectionTeam__grid'>
            {false && (
              <div className='si-selectionTeam__grid-lhs'>
                <div className='si-selectionTeam-card'>
                  <Typo
                    transKey={'selection_team_lbl_current_team'}
                    component='p'
                    className='si-matchCardSkill__list-lbl'
                  >
                    Current Team
                  </Typo>
                  <div className='si-matchCardSkill__list'>
                    <div className='si-matchCardSkill__list-item'>
                      <FormationPlayerCard thumbnail={'1'} />
                      <PlayerSkillIcon skillType={1} />
                    </div>
                    <div className='si-matchCardSkill__list-item'>
                      <FormationPlayerCard thumbnail={'1'} />
                      <PlayerSkillIcon skillType={2} />
                    </div>
                    <div className='si-matchCardSkill__list-item'>
                      <FormationPlayerCard thumbnail={'1'} />
                      <PlayerSkillIcon skillType={3} />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {false && (
              <div className='si-selectionTeam__grid-rhs'>
                <div
                  className={`si-selectionTeam-card ${
                    true ? '' : 'si-selectionTeam-card__prevTeam'
                  }`}
                >
                  <Typo
                    transKey={'selection_team_lbl_previous_team'}
                    component='p'
                    className='si-matchCardSkill__list-lbl'
                  >
                    Previous Team
                  </Typo>
                  <div className='si-matchCardSkill__list'>
                    <div className='si-matchCardSkill__list-item'>
                      <FormationPlayerCard thumbnail={'1'} />
                      <PlayerSkillIcon skillType={1} />
                    </div>
                    <div className='si-matchCardSkill__list-item'>
                      <FormationPlayerCard thumbnail={'1'} />
                      <PlayerSkillIcon skillType={2} />
                    </div>
                    <div className='si-matchCardSkill__list-item'>
                      <FormationPlayerCard thumbnail={'1'} />
                      <PlayerSkillIcon skillType={3} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div> */}
      </Overlays>
    </>
  );
};

export default OverlaySelectedTeam;
